import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock } = FiIcons;

function Timer({ timeLeft, totalTime }) {
  const percentage = (timeLeft / totalTime) * 100;
  
  const getTimerColor = () => {
    if (percentage > 60) return 'from-green-500 to-emerald-600';
    if (percentage > 30) return 'from-yellow-500 to-orange-500';
    return 'from-red-500 to-pink-600';
  };

  const getBackgroundColor = () => {
    if (percentage > 60) return 'bg-green-500/20';
    if (percentage > 30) return 'bg-yellow-500/20';
    return 'bg-red-500/20';
  };

  return (
    <div className={`${getBackgroundColor()} backdrop-blur-sm rounded-2xl p-4 mb-6`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiClock} className="text-white" />
          <span className="text-white font-medium">Time</span>
        </div>
        <div className="text-white font-bold text-lg">
          {timeLeft}s
        </div>
      </div>
      
      <div className="w-full bg-white/20 rounded-full h-3">
        <motion.div
          className={`h-3 rounded-full bg-gradient-to-r ${getTimerColor()}`}
          initial={{ width: '100%' }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.3 }}
        />
      </div>
      
      {percentage <= 30 && (
        <motion.p
          animate={{ opacity: [1, 0.5, 1] }}
          transition={{ duration: 0.5, repeat: Infinity }}
          className="text-center text-white font-medium mt-2"
        >
          ⚠️ Time running out!
        </motion.p>
      )}
    </div>
  );
}

export default Timer;